/*
 *
 * RouteHeader
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 26-Nov-2024
 */

import React, { useEffect, useState } from 'react'
import './RouteHeader.scss'
import { useLocation, useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { GridIcon, PersonRound } from '@nexidigital/iconlibrary'
import MerchantNavigationButton from '@nexidigital/merchantnavigationbutton'
import { useMobileDetect } from 'Hoc/ListenerProvider'
import { getBankFromPath } from 'Utility/bankMethods'
import BaseHeader from 'Components/BaseHeader'
import MobileNavBar from 'Components/MobileNavBar'
import MultiMerchantSelect from 'Components/MultiMerchantSelect'
import { routesList } from 'Schemas/routesList'
import { messages } from './languageModule'

const RouteHeader = () => {
  const intl = useIntl()
  const { isSmallScreen } = useMobileDetect()
  const [showMenu, setShowMenu] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const isProfilePath = location.pathname.includes(routesList.profile.goToProfile)

  const removeOverflowClass = () => document.body.classList.remove('mobile-menu-no-scroll')


  useEffect(() => {
    if (!isSmallScreen) {
      setShowMenu(false)
      removeOverflowClass()
    }
  }, [isSmallScreen])

  const handleMenuToggle = () => {
    setShowMenu(!showMenu)
    if (showMenu) {
      removeOverflowClass()
    } else {
      document.body.classList.add('mobile-menu-no-scroll')
    }
  }

  return (
    <BaseHeader bank={getBankFromPath()}>
      <MultiMerchantSelect removeMobileMenuOverflow={removeOverflowClass} />
      <div className='navButtons'>
        <MerchantNavigationButton
          label={intl.formatMessage(messages.profileTitleText)}
          ariaLabel={intl.formatMessage(messages.profileTitleText)}
          onClick={() => {removeOverflowClass(); navigate(routesList.profile.goToProfile)}}
          icon={<PersonRound size='24' type='line' />}
          iconSelected={<PersonRound size='24' type='fill' />}
          selected={isProfilePath}
          onlyIcon={isSmallScreen}
        />
        {isSmallScreen && (
          <MerchantNavigationButton
            ariaLabel={intl.formatMessage(messages.mobileNavAltText)}
            onClick={handleMenuToggle}
            icon={<GridIcon size='24' type='line' />}
            iconSelected={<GridIcon size='24' type='fill' />}
            selected={showMenu}
            onlyIcon
          />
        )}
      </div>
      {showMenu && <MobileNavBar closeMobileMenu={handleMenuToggle} />}
    </BaseHeader>
  )
}

RouteHeader.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  /** Description of prop "baz". */
}

RouteHeader.defaultProps = {
  // Add here some default propTypes values
}

export default RouteHeader
